import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { ArticleHeading1 } from '@cian/ui-kit';

import { newbuildingStatusChange } from '../../actions';
import { Projects as ProjectsComponent } from '../../components/Projects';
import { Tabs } from '../../components/tabs';
import { ViewModeSwitch } from '../../components/ViewModeSwitch';
import { getFilters, getNewbuildingsCounts } from '../../selectors';
import { addQueryParameter } from '../../utils';
import { Filters } from '../Filters';
import { ProjectsList } from '../ProjectsList';

import { getTabs } from './helpers';
import { trackShowListingProjects } from './tracking';
import { TViewMode } from './types';
import { TThunkDispatch } from '../../types/redux/thunk';
import { ENewbuildingStatus } from '../../types/filters';

export function Projects() {
  const [mode, setMode] = React.useState<TViewMode>('table');
  const dispatch: TThunkDispatch = useDispatch();
  const filters = useSelector(getFilters);
  const counts = useSelector(getNewbuildingsCounts);
  const tabs = React.useMemo(() => getTabs(counts), [counts]);

  const handleTabChange = React.useCallback(
    (newTab: ENewbuildingStatus) => {
      dispatch(newbuildingStatusChange(newTab));
      addQueryParameter('newbuildingStatus', newTab);
    },
    [dispatch],
  );

  return (
    <ActionAfterViewed callback={trackShowListingProjects}>
      <ProjectsComponent
        title={<ArticleHeading1>Объекты от застройщика</ArticleHeading1>}
        tabs={<Tabs tabs={tabs} activeTab={filters.newbuildingStatus} onChange={handleTabChange} />}
        viewMode={<ViewModeSwitch mode={mode} onModeChange={setMode} />}
        filters={<Filters />}
        content={<ProjectsList mode={mode} />}
      />
    </ActionAfterViewed>
  );
}
